import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { useUserPermission } from "@hooks/users";
import {
  Controller,
  useFormContext
  /*, useFieldArray*/
} from "react-hook-form";

import InputWithAddOptions from "@components/input/InputWithAddOptions";
import BlackTooltip from "@components/tooltip/BlackTooltip";

import { checkEnterpriseId } from "@helpers/_functions";

import useCLothes from "./hooksClothes";

export default function SharedClothes({ setSuperZIndex, readOnly, isEnterprisePage }) {
  const { t } = useTranslation("pages.employés.healthPrecision");
  const { TYPES, deleteById, upsert } = useCLothes();
  const clothes = useReduxSelector(
    ({ enterpriseEmployeData: { clothes } }) => clothes?.list
  );
  const { control } = useFormContext();
  const { canAccessClothingSize } = useUserPermission();
  const readOnlyAccess = useMemo(() => {
    return isEnterprisePage ? readOnly : !canAccessClothingSize;
  }, [readOnly, isEnterprisePage, canAccessClothingSize])
  return (
    <div
      className="arh-flex arh-w-full arh-flex-wrap arh-items-center arh-justify-between arh-pb-[2rem] arh-pl-[5.8rem] arh-pr-[1rem] tablet-850:arh-items-start tablet-850:arh-justify-start tablet-850:arh-gap-x-5 tablet-850:arh-gap-y-0 tablet-850:!arh-pl-[2.5rem] tablet-850:!arh-pr-[1rem]"
    >
      {TYPES?.map((_type) => (
        <Controller
          key={_type._id}
          control={control}
          name={`clothes[${_type._id}]`}
          defaultValue={null}
          //rules={{ required: true }}
          render={({
            field: { onChange, value, name },
            fieldState: { invalid }
          }) => (
            <div className="arh-mb-[1.75rem] arh-w-[23%] tablet-850:!arh-mr-0 tablet-850:arh-min-w-0 tablet-850:!arh-w-[calc(50%_-_0.625rem)] tablet-850:!arh-flex-[0_0_calc(50%_-_0.625rem)]">
              <label
                className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium 
                ${readOnlyAccess ? "arh-text-greyDisabledText" : invalid ? "arh-text-[#F60A20]" : "arh-text-black"}
                  `}
              >
                {t(_type.label)}
              </label>
              <BlackTooltip
                title={(value || []).map((item) => item?.name).join(", ")}
                placement="top"
              >
                <span className="arh-inline-block arh-w-full">
                  <InputWithAddOptions
                    defaultText={t(_type.label)}
                    optionsList={clothes?.filter((_clothe) => _clothe.type === _type._id)}
                    secondDefaultText={t("Ajouter")}
                    name={name}
                    value={value || []}
                    optionListLabel="name"
                    onChange={onChange}
                    addItem={(body) =>
                      upsert(
                        {
                          ...body,
                          type: _type._id,
                          Enterprise: checkEnterpriseId()
                        },
                        _type._id
                      )
                    }
                    editItem={(body) =>
                      upsert(
                        {
                          ...body,
                          type: _type._id,
                          Enterprise: checkEnterpriseId()
                        },
                        _type._id
                      )
                    }
                    deleteItem={(body) => deleteById(body, _type._id)}
                    validateDropdown={invalid}
                    multiple
                    setSuperZIndex={setSuperZIndex}
                    showAction={isEnterprisePage}
                    hideAdd={!isEnterprisePage}
                    disabled={readOnlyAccess}
                  />
                </span>
              </BlackTooltip>
            </div>
          )}
        />
      ))}
    </div>
  );
}
